import { useState } from 'react'
import { Input, Select } from '../../components/forms'
import Button from '../../components/ui/Button'

const ROLE_OPTIONS = [
  { value: 'member', label: 'Member' },
  { value: 'admin', label: 'Admin' },
]

function InviteForm({ onSubmit, onCancel, loading = false, businesses = [] }) {
  const [formData, setFormData] = useState({
    email: '',
    name: '',
    role: 'member',
    businessIds: [],
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleBusinessToggle = (businessId) => {
    setFormData(prev => ({
      ...prev,
      businessIds: prev.businessIds.includes(businessId)
        ? prev.businessIds.filter(id => id !== businessId)
        : [...prev.businessIds, businessId]
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(formData)
  }

  return (
    <form onSubmit={handleSubmit}>
      <p className="text-muted mb-4">
        Send a magic link to add a new team member. They'll receive an email and can log in instantly.
      </p>

      <Input
        label="Email Address"
        name="email"
        type="email"
        value={formData.email}
        onChange={handleChange}
        placeholder="colleague@example.com"
        required
      />

      <Input
        label="Name"
        name="name"
        type="text"
        value={formData.name}
        onChange={handleChange}
        placeholder="John Doe"
      />

      <Select
        label="Role"
        name="role"
        value={formData.role}
        onChange={handleChange}
        options={ROLE_OPTIONS}
      />

      {businesses.length > 0 && (
        <div className="form-group">
          <label className="form-label">Grant Access to Businesses</label>
          <p className="text-muted text-sm mb-2">
            Select which businesses this user can access (optional, can be set later)
          </p>
          <div className="business-access-list">
            {businesses.map(business => (
              <label key={business.id} className="checkbox-item">
                <input
                  type="checkbox"
                  checked={formData.businessIds.includes(business.id)}
                  onChange={() => handleBusinessToggle(business.id)}
                />
                <span className="checkbox-label">
                  {business.emoji} {business.name}
                </span>
              </label>
            ))}
          </div>
        </div>
      )}

      <div className="flex justify-between gap-3 mt-6">
        <Button type="button" variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" variant="primary" loading={loading}>
          Send Invite
        </Button>
      </div>
    </form>
  )
}

export default InviteForm
